import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import ApplicationHeader from '../../pages/Global/ApplicationHeader';
import ApplicationFooter from '../../pages/Global/ApplicationFooter';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 5;
const APP_BAR_DESKTOP = 16;

const RootStyle = styled('div')({
  minHeight: '100%',
  overflow: 'hidden',
  background: 'rgb(239, 241, 245)'
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  // paddingTop: APP_BAR_MOBILE,
  paddingBottom: theme.spacing(7),
  paddingTop: theme.spacing(9),
  [theme.breakpoints.up('lg')]: {
    // paddingTop: theme.spacing(5)
    // paddingLeft: theme.spacing(2),
    // paddingRight: theme.spacing(2)
  }
}));

// ----------------------------------------------------------------------
/**
 * Common component with sidebar section
 * @class
 * @return {React.ReactElement} - React component
 */
function DashboardApplication() {
  const [open, setOpen] = useState(false);
  /**
   * Set sidebar open or close
   * @type {boolean}
   */
  const toggle = Boolean(!open);

  return (
    <RootStyle>
      <ApplicationHeader />
      <MainStyle>
        <Outlet />
      </MainStyle>
      <ApplicationFooter />
    </RootStyle>
  );
}
export default DashboardApplication;
